import React from 'react';

const RowOfSeparatedChildren = ({children}) => {
  const childContainerStyle = {borderRight: '1px solid rgba(0, 0, 0, 0.17)'};
  const childrenElements = React.Children.map(children, (child, index) => {
    const isLastChildren = index != (children.length -1)
    const style =  isLastChildren ? childContainerStyle : null
    return <span style={style}>
      {child}
    </span>
  })
  return <div style={{display:'flex', flexDirection:'row'}}>
        {childrenElements}
      </div>
}
export default RowOfSeparatedChildren


/** WEBPACK FOOTER **
 ** ./app/components/RowOfSepararedChildren.jsx
 **/